import React, { Fragment } from 'react'
import * as Logger from 'loglevel'

import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import * as HubConstant from '../util/HubConstant'

import { MultiValsSelector } from '../../../MultiValsSelector/MultiValsSelector'
import { FolderTreeSelector } from '../../../MultiValsSelector/FolderTreeSelector'
import * as _ from 'lodash'

// In this sense, node = Production Centre

export const HubFilterType = Object.freeze({
  PRODUCTION_CENTRE: 0,
  CATEGORY: 1,
  HAS_MEDIA: 2,
  URGENT: 3
})

class FilterBar extends React.Component {
  constructor(props) {
    Logger.debug(`Constructing NodeSelector`)
    super(props)
    this.state = {
      // New ones:
      filters: [
        // structure:
        // {
        //     type: HubFilterType,
        //     title: "string",
        //     icon: IconDefinition,
        // For filter dropdown:
        //     availableFilterObjs?: Array<objsToFilter>,
        //     toFilter? (STATE): Array<toFilter>,
        //     availableFilterGroups?: Array<filterGroups>
        // For filter checkbox:
        //     state? (STATE): HubConstant.HUB_CHECKBOX_STATE
        // }
      ]
    }
  }

  componentWillMount() {
    this.setFiltersState(this.props.filters, -1)
  }

  isArrayEqual = (x, y) => {
    return _.isEmpty(_.xorWith(x, y, _.isEqual))
  }

  componentWillReceiveProps(nextPropsFromRedux) {
    if (
      !!this.props.filters &&
      !this.isArrayEqual(this.props.filters, nextPropsFromRedux.filters)
    )
      // data takes a while to fetch
      this.setFiltersState(nextPropsFromRedux.filters, -1)
  }

  flushAllFilters = async (objsToFilter) => {
    await this.setFiltersState(this.state.filters, -1)
    this.props.onChangeFilters(this.state.filters, true) // can do anything like data in other table
  }

  onSetSelectedVals = async (newFilterArr, index) => {
    await this.setFiltersState(this.state.filters, index, newFilterArr)
    this.props.onChangeFilters(this.state.filters, true) // can do anything like data in other table
  }

  setFiltersState = async (oldFilters, index, newVal) => {
    return new Promise((resolve, reject) => {
      // for -1 index, initialize/refresh:
      var updatedFilters = []

      oldFilters.forEach((filter, i) => {
        var updatedFilter = Object.assign({}, filter)
        if (filter.type === HubConstant.HUB_FILTER_TYPE.CHECKBOX) {
          updatedFilter.state =
            index === -1
              ? HubConstant.HUB_CHECKBOX_STATE.EMPTY
              : index === i
              ? newVal
              : filter.state
        } else if (
          filter.type === HubConstant.HUB_FILTER_TYPE.MULTI_VAL_SELECTOR || filter.type === HubConstant.HUB_FILTER_TYPE.FOLDER_TREE_SELECTOR
        ) {
          updatedFilter.toFilter =
            index === -1 ? [] : index === i ? newVal : filter.toFilter
        }
        updatedFilters.push(updatedFilter)
      })
      this.setState({ filters: updatedFilters }, () => {
        resolve(true)
      })
    })
  }

  onClickCheckbox = (event, filter, index) => {
    var newState = HubConstant.HUB_CHECKBOX_STATE.EMPTY
    switch (filter.state) {
      case HubConstant.HUB_CHECKBOX_STATE.EMPTY:
        newState = HubConstant.HUB_CHECKBOX_STATE.TICK
        break
      case HubConstant.HUB_CHECKBOX_STATE.TICK:
        newState = HubConstant.HUB_CHECKBOX_STATE.CROSS
        break
      case HubConstant.HUB_CHECKBOX_STATE.CROSS:
        newState = HubConstant.HUB_CHECKBOX_STATE.EMPTY
        break
      default:
        break
    }
    // await this.setFiltersState(this.state.filters, index, newState);
    return Promise.resolve(
      this.setFiltersState(this.state.filters, index, newState)
    ).then(() => {
      this.props.onChangeFilters(this.state.filters, false) // can do anything like data in other table, doesn't require api refresh data
    })
  }

  renderFilterCheckbox(filter, index) {
    // State:
    //   checkbox filter:
    //     { type: HubFilterType.CHECKBOX, title: "Has Media", icon: faPlaneArrival, state: HUB_CHECKBOX_STATE }

    return (
      <Button
        key={`filterCheckbox_${index}`}
        className={`checkFilter ${
          filter.state === HubConstant.HUB_CHECKBOX_STATE.EMPTY
            ? 'InActive'
            : ''
        }`}
        onClick={(e) => this.onClickCheckbox(e, filter, index)}
      >
        <label
          className='checkboxContainer rightCheckbox'
          style={{ pointerEvents: 'none' }}
        >
          <FontAwesomeIcon icon={filter.icon} />
          {' ' + filter.title}
          <input
            id={`filterbar_${index}`}
            name={`filterbar_${index}`}
            className={`filterGroupChild ${
              filter.state === HubConstant.HUB_CHECKBOX_STATE.CROSS
                ? 'cross'
                : ''
            }`}
            type='checkbox'
            style={{ pointerEvents: 'none' }}
            checked={filter.state}
            readOnly
          />
          <span className='checkmark' />
        </label>
      </Button>
    )
  }

  renderFilterOptions(filters) {
    return filters.map((filter, index) => {
      if (filter.type === HubConstant.HUB_FILTER_TYPE.CHECKBOX) {
        return this.renderFilterCheckbox(filter, index)
      } else if (
        filter.type === HubConstant.HUB_FILTER_TYPE.MULTI_VAL_SELECTOR
      ) {
        return (
          <Fragment key={`multiValsSelector_${index}`}>
            <MultiValsSelector
              id={index}
              title={filter.title}
              toggleIcon={filter.icon}
              availableVals={filter.availableFilterObjs}
              selectedVals={filter.toFilter}
              valGroups={filter.availableFilterGroups}
              setSelectedVals={this.onSetSelectedVals}
              isLoading={this.props.isLoading}
            />
          </Fragment>
        )
      } else if (
        filter.type === HubConstant.HUB_FILTER_TYPE.FOLDER_TREE_SELECTOR
      ){
        return (
          <Fragment key={`folderTree_${index}`}>
            <FolderTreeSelector    
              id={index}    
              title={filter.title}
              toggleIcon={filter.icon}
              selectedVals={filter.toFilter}
              availableVals={filter.availableFilterObjs}
              setSelectedVals={this.onSetSelectedVals}
            />
          </Fragment>
        )
      }
    })
  }

 render() {
    return (
      <div className='filterBar'>
        <span className='filterTitle'>Filter By: </span>
        <Fragment>
          {this.renderFilterOptions(this.state.filters)}
          <OverlayTrigger
            key='bottom'
            placement='bottom'
            overlay={
              <Tooltip id='clearAllFilters-tooltip-bottom'>
                Clear all filters
              </Tooltip>
            }
          >
            <FontAwesomeIcon
              className='filterSearchPlaceholderCancel'
              icon={faTimesCircle}
              onClick={this.flushAllFilters}
            />
          </OverlayTrigger>
        </Fragment>
      </div>
    )
  }
}

export default FilterBar
